import { useState, useRef, useEffect } from 'react';
import { Collapse } from 'react-bootstrap';

import './benchmark-activities.css';

const CopyText = ({ text }: { text: string }) => {
    const [copied, setCopied] = useState(false);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => setCopied(false), 1200);
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <div className='benchmark-error-text' onClick={handleCopy} >
            {copied ? "Error Text Copied to Clipboard!" : text}
        </div>
    );
};

type BenchmarkErrorMessageProps = {
    children: React.ReactNode,
    title?: string,
    error?: string | undefined,
};

const BenchmarkErrorMessage = ({ children, title = '', error }: BenchmarkErrorMessageProps) => {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <div className='row'>
            <div className='col'>
                <div className='row h4 text-center'>
                    <p>
                        {title}
                    </p>
                </div>
                <div className='row'>
                    {children}
                </div>
                { error ?
                <div className='row ps-3'>
                    <button
                        className='btn btn-sm btn-danger'
                        onClick={() => setOpen(!open)}
                    >
                        {open ? 'hide error' : 'view error'}
                    </button>
                </div>
                : <></>
                }
                { error ?
                    <div className='row'>
                        <Collapse in={open}>
                            <div className='col ps-3 m-3 benchmark-error-panel'>
                                <CopyText text={error} />
                            </div>
                        </Collapse>
                    </div>
                    : <></>
                }
            </div>
        </div>
    );
};

export default BenchmarkErrorMessage;